
import Vue from 'vue';
import { Component, InjectReactive, Prop, ProvideReactive } from 'vue-property-decorator';
import { DueDiligenceAccountHolderDetails } from '@/store/dueDiligence/types';
import CPDueDiligenceAccountHolderNameDetails from './CPDueDiligenceAccountHolderNameDetails.vue';
import CPDueDiligenceAccountHolderAddressDetails from './CPDueDiligenceAccountHolderAddressDetails.vue';
import CPDueDiligenceAccountHolderPersonalInfoDetails from './CPDueDiligenceAccountHolderPersonalInfoDetails.vue';
import CPDueDiligenceAccountHolderTaxDetails from './CPDueDiligenceAccountHolderTaxDetails.vue';
import CPDueDiligenceAccountHolderEmploymentDetails from './CPDueDiligenceAccountHolderEmploymentDetails.vue';
import { JointAccountType, JointAccountTypes } from '@/types/jointAccountType';
import CPDueDiligenceAccountHolderContactDetails from './CPDueDiligenceAccountHolderContactDetails.vue';
import { AccountTypeFlags } from '@/store/openAccount/types';

@Component({
    components: {
        CPDueDiligenceAccountHolderNameDetails,
        CPDueDiligenceAccountHolderContactDetails,
        CPDueDiligenceAccountHolderAddressDetails,
        CPDueDiligenceAccountHolderPersonalInfoDetails,
        CPDueDiligenceAccountHolderTaxDetails,
        CPDueDiligenceAccountHolderEmploymentDetails
    }
})
export default class CPDueDiligenceAccountHolderDetails extends Vue {
    @Prop({
        type: Object as () => DueDiligenceAccountHolderDetails,
        required: true
    })
    public accountHolder!: DueDiligenceAccountHolderDetails;
    
    @Prop({ default: JointAccountTypes.Primary })
    @ProvideReactive()
    public readonly jointAccountType!: JointAccountType;

    @Prop({ required: false })
    public readonly accountHolderTitle!: string | null;

    @InjectReactive()
    public readonly accountType!: AccountTypeFlags;
}
